import { IconNewTrash } from "../../../../../../icons";
import IconButton from "../../../../../../components/IconButton";
import { Points } from "../../../../model";

interface IconTrashProps {
    arrayPoints: Points[]
    remove: (index: number)=> void 
    index: number
}

export default function IconTrashComponent({ arrayPoints, remove, index }: IconTrashProps) {
    return (
        <>
            {arrayPoints?.length > 1 && arrayPoints?.length === (index + 1) ? (
                <IconButton
                    icon={IconNewTrash}
                    className="flex justify-center items-center"
                    onClick={() => remove(index)}
                />
            ) : (
                <div className="trash-invisible">Lixo</div>
            )}
        </>
    )
}